var _a;
import 'wicg-inert';
import { Theme } from './front/Theme';
import { Advert } from './modules/Advert/Advert';
import { SiteHeader } from './modules/SiteHeader/SiteHeader';
import { FactsBox } from './modules/FactsBox/FactsBox';
import { FaqList } from './modules/FaqList/FaqList';
import { Newsletter } from "./modules/Newsletter/Newsletter";
import { SharingButtons } from './modules/SharingButtons/SharingButtons';
import { ConferenceBookingBtn } from './modules/ConferenceBookingBtn/ConferenceBookingBtn';
import { ConferenceProgramme } from "./modules/ConferenceProgramme/ConferenceProgramme";
import { MagazineIssuesList } from "./modules/MagazineIssuesList/MagazineIssuesList";
import { Card } from "./modules/Card/Card";
import { SliderCards } from "./modules/SliderCards/SliderCards";
import { Cta } from './modules/Cta/Cta';
import { InnerContainer } from './modules/InnerContainer/InnerContainer';
import { RelatedContent } from './modules/RelatedContent/RelatedContent';
import { Single } from './layouts/Single/Single';
import { SingleArticle } from './layouts/SingleArticle/SingleArticle';
import { ListJobs } from "./layouts/ListJobs/ListJobs";
import { SingleCourse } from "./layouts/SingleCourse/SingleCourse";
import { Search } from './layouts/Search/Search';
import { initCacheControls } from './front/admin/cache-controls';
import { onDocumentReady } from './front/lib/utils';
import { ListArticles } from './layouts/ListArticles/ListArticles';
import { ArticlesGrid } from './modules/ArticlesGrid/ArticlesGrid';
if (((_a = document.documentElement.dataset) === null || _a === void 0 ? void 0 : _a.state) !== 'SystemError') {
    onDocumentReady(init);
}
function init() {
    Theme.init({
        modules: {
            Advert,
            ArticlesGrid,
            FactsBox,
            FaqList,
            SiteHeader,
            Newsletter,
            SharingButtons,
            ConferenceProgramme,
            ConferenceBookingBtn,
            SliderCards,
            MagazineIssuesList,
            Card,
            Cta,
            InnerContainer,
            RelatedContent,
        },
        layouts: {
            ListJobs,
            SingleCourse,
            Search,
            SingleArticle,
            Single,
            ListArticles,
        },
    });
    if (document.body.classList.contains('logged-in')) {
        initCacheControls();
    }
    document.documentElement.classList.remove('is--loading');
}
